/**
 * @generated SignedSource<<fb16ca18635ebbe1b1a9692b6a3342c7>>
 * @relayHash 405f78f112043d9bd7916e4a0c2e73db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f63daae65c4a23c9e99ee66107899b8095d4ce31bb1cd7d6958f7102989b7d0

import type { ConcreteRequest } from 'relay-runtime';
export type JiraForgeEnvironmentType = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type JiraVisibilityControlMechanism = "AppAccessRules" | "DisplayConditions" | "UnlicensedAccess" | "%future added value";
export type JiraExtensionRenderingContextInput = {
  issueKey?: string | null;
  issueTypeId?: string | null;
  portalId?: string | null;
  projectKey?: string | null;
  requestTypeId?: string | null;
};
export type doFetchWithGraphQLErrorsTrackingQuery$variables = {
  cloudId: string;
  context: JiraExtensionRenderingContextInput;
  includeHidden: boolean;
  includeScopes: boolean;
  types: ReadonlyArray<string>;
};
export type doFetchWithGraphQLErrorsTrackingQuery$data = {
  readonly jira: {
    readonly forge: {
      readonly extensions: ReadonlyArray<{
        readonly appVersion: string;
        readonly consentUrl: string | null;
        readonly egress: ReadonlyArray<{
          readonly addresses: ReadonlyArray<string> | null;
          readonly category: string | null;
          readonly inScopeEUD: boolean | null;
          readonly type: string | null;
        } | null>;
        readonly environmentId: string;
        readonly environmentKey: string;
        readonly environmentType: JiraForgeEnvironmentType;
        readonly hiddenBy?: JiraVisibilityControlMechanism | null;
        readonly id: string;
        readonly installationConfig: ReadonlyArray<{
          readonly key: string;
          readonly value: boolean;
        }> | null;
        readonly installationId: string;
        readonly license: {
          readonly active: boolean;
          readonly billingPeriod: string | null;
          readonly capabilitySet: string | null;
          readonly ccpEntitlementId: string | null;
          readonly ccpEntitlementSlug: string | null;
          readonly isEvaluation: boolean | null;
          readonly subscriptionEndDate: AGG$DateTime | null;
          readonly supportEntitlementNumber: string | null;
          readonly trialEndDate: AGG$DateTime | null;
          readonly type: string | null;
        } | null;
        readonly moduleId: string | null;
        readonly properties: AGG$JSON;
        readonly sandboxPolicies: ReadonlyArray<string> | null;
        readonly scopes?: ReadonlyArray<string>;
        readonly type: string;
        readonly userAccess: {
          readonly enabled: boolean;
          readonly hasAccess: boolean;
        } | null;
      }> | null;
    };
  } | null;
};
export type doFetchWithGraphQLErrorsTrackingQuery = {
  response: doFetchWithGraphQLErrorsTrackingQuery$data;
  variables: doFetchWithGraphQLErrorsTrackingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHidden"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeScopes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "types"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraForgeQuery",
        "kind": "LinkedField",
        "name": "forge",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "context",
                "variableName": "context"
              },
              {
                "kind": "Variable",
                "name": "includeHidden",
                "variableName": "includeHidden"
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "types"
              }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              {
                "condition": "includeHidden",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                  }
                ]
              },
              {
                "condition": "includeScopes",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "scopes"
                  }
                ]
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "moduleId"
              },
              {
                "kind": "ScalarField",
                "name": "environmentId"
              },
              {
                "kind": "ScalarField",
                "name": "environmentKey"
              },
              {
                "kind": "ScalarField",
                "name": "environmentType"
              },
              {
                "kind": "ScalarField",
                "name": "installationId"
              },
              {
                "kind": "ScalarField",
                "name": "appVersion"
              },
              {
                "kind": "ScalarField",
                "name": "consentUrl"
              },
              {
                "kind": "ScalarField",
                "name": "properties"
              },
              {
                "concreteType": "JiraUserAppAccess",
                "kind": "LinkedField",
                "name": "userAccess",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasAccess"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeAppEgressDeclaration",
                "kind": "LinkedField",
                "name": "egress",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "addresses"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "inScopeEUD"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "sandboxPolicies"
              },
              {
                "concreteType": "JiraForgeInstallationConfigExtension",
                "kind": "LinkedField",
                "name": "installationConfig",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeExtensionLicense",
                "kind": "LinkedField",
                "name": "license",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "active"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "supportEntitlementNumber"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "subscriptionEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEvaluation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "billingPeriod"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementSlug"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "capabilitySet"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "doFetchWithGraphQLErrorsTrackingQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "doFetchWithGraphQLErrorsTrackingQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "3f63daae65c4a23c9e99ee66107899b8095d4ce31bb1cd7d6958f7102989b7d0",
    "metadata": {},
    "name": "doFetchWithGraphQLErrorsTrackingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c6c636ea5bd0af3f6818f27319aafd11";

export default node;
